import React from 'react';
import ProfileTableRecord from './ProfileTableRecord';

export interface IProfileTableProps {
  valueClassName: string;
  data: Array<[string, string]>;
}

const ProfileTable: React.FC<IProfileTableProps> = (props: IProfileTableProps) => {
    let rows = [];
    for (let i = 0; i < props.data.length; ++i) {
        rows.push(
            <ProfileTableRecord
                header={props.data[i][0]}
                value={props.data[i][1]}
                valueClassName={props.valueClassName} />
        );
    }
    return (
      <table className="ProfileTable">
        {rows}
      </table>
    );
  }
  
  export default ProfileTable;